
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_vdkpj_1hyq0_20",
  "item-wrapper": "awsui_item-wrapper_vdkpj_1hyq0_56",
  "group": "awsui_group_vdkpj_1hyq0_60",
  "divider": "awsui_divider_vdkpj_1hyq0_64"
};
  